import { Controller } from "@hotwired/stimulus"

// Handles custom Turbo confirm dialogs using DaisyUI modal
// Usage: Add data-controller="confirm" to the modal element in layout

export default class extends Controller {
  static targets = ["dialog", "message", "confirmButton"]

  connect() {
    // Store reference globally so Turbo.setConfirmMethod can access it
    window.confirmController = this
  }

  disconnect() {
    if (window.confirmController === this) {
      window.confirmController = null
    }
  }

  show(message) {
    return new Promise((resolve) => {
      this.resolver = resolve
      this.messageTarget.textContent = message
      this.dialogTarget.showModal()
    })
  }

  confirm() {
    this.dialogTarget.close()
    if (this.resolver) {
      this.resolver(true)
      this.resolver = null
    }
  }

  cancel() {
    this.dialogTarget.close()
    if (this.resolver) {
      this.resolver(false)
      this.resolver = null
    }
  }
}
